export const FETCH_EMPLOYEE_DETAILS_REQUEST = "FETCH_EMPLOYEE_DETAILS_REQUEST";
export const FETCH_EMPLOYEE_DETAILS_SUCCESS = "FETCH_EMPLOYEE_DETAILS_SUCCESS";
export const FETCH_EMPLOYEE_DETAILS_FAILURE = "FETCH_EMPLOYEE_DETAILS_FAILURE";

export const FETCH_EMPLOYEE_OTHER_INFO_REQUEST = "FETCH_EMPLOYEE_OTHER_INFO_REQUEST";
export const FETCH_EMPLOYEE_OTHER_INFO_SUCCESS = "FETCH_EMPLOYEE_OTHER_INFO_SUCCESS";
export const FETCH_EMPLOYEE_OTHER_INFO_FAILURE = "FETCH_EMPLOYEE_OTHER_INFO_FAILURE";

export const FETCH_EMPLOYEE_NO_PAY_REQUEST = "FETCH_EMPLOYEE_NO_PAY_REQUEST";
export const FETCH_EMPLOYEE_NO_PAY_SUCCESS = "FETCH_EMPLOYEE_NO_PAY_SUCCESS";
export const FETCH_EMPLOYEE_NO_PAY_FAILURE = "FETCH_EMPLOYEE_NO_PAY_FAILURE";

export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_REQUEST";
export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_SUCCESS";
export const FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE = "FETCH_EMPLOYEE_PRE_YEAR_SUMMARY_FAILURE";

export const FETCH_EMPLOYEE_LIST_REQUEST = "FETCH_EMPLOYEE_LIST_REQUEST";
export const FETCH_EMPLOYEE_LIST_SUCCESS = "FETCH_EMPLOYEE_LIST_SUCCESS";
export const FETCH_EMPLOYEE_LIST_FAILURE = "FETCH_EMPLOYEE_LIST_FAILURE";

export const CLEAR_EMPLOYEE_DETAILS = "CLEAR_EMPLOYEE_DETAILS";
